// src/components/ProductCard.js
import React from "react";
import { Link } from "react-router-dom";
import "./ProductCard.css";

export default function ProductCard({ product }) {
  if (product.comingSoon) {
    return (
      <div className="product-card product-card--soon">
        <div className="product-card__soon-badge">Coming Soon</div>
        <div className="product-card__soon-icon">🌱</div>
        <h3 className="product-card__title">New Product</h3>
        <p className="product-card__desc">
          We are continuously working on expanding our range to support sustainable agriculture.
        </p>
      </div>
    );
  }

  return (
    <div className="card product-card">
      {/* Image */}
      <div className="product-card__image-wrap">
        {product.imageUrl ? (
          <img src={product.imageUrl} alt={product.name} className="product-card__image" />
        ) : (
          <div className="product-card__placeholder">
            <span>🌿</span>
            <p>{product.name}</p>
          </div>
        )}
        {product.featured && <span className="product-card__featured">⭐ Featured</span>}
      </div>

      {/* Content */}
      <div className="product-card__body">
        <div className="product-card__badges">
          {product.badges?.slice(0, 2).map((b) => (
            <span key={b} className="badge">{b}</span>
          ))}
        </div>
        <h3 className="product-card__title">{product.name}</h3>
        <p className="product-card__tagline">{product.tagline}</p>
        <p className="product-card__desc">
          {product.description?.substring(0, 120)}...
        </p>

        {/* Variants */}
        {product.variants?.length > 0 && (
          <div className="product-card__variants">
            {product.variants.map((v) => (
              <span key={v.sku} className="product-card__variant">
                {v.size}
              </span>
            ))}
          </div>
        )}

        <div className="product-card__actions">
          <Link to={`/products/${product.slug}`} className="btn btn-outline">
            View Details
          </Link>
          <a
            href={`mailto:${product.enquiryEmail || "sales@sunaharco.com"}?subject=Enquiry: ${product.name}`}
            className="btn btn-primary"
          >
            Enquire Now
          </a>
        </div>
      </div>
    </div>
  );
}
